import {collection, component, field, identifier} from "@fedeltapointofsale/data-client";
import {PricingScheduleData} from "../pricing-schedule/pricing-schedule.data";
import {MixAndMatchReferenceData} from "../mix-and-match/mix-and-match.data";
import {TypedTerminalReferenceData} from "../../pos/terminal/terminal-reference.data";

export class MixAndMatchScheduleData extends PricingScheduleData<MixAndMatchScheduleData> {
    @identifier mixAndMatchScheduleId: number;
    @field name: string;
    @field allTerminals: boolean = false;
    @field discontinued: boolean;
    @component mixAndMatch: MixAndMatchReferenceData;
    @collection(TypedTerminalReferenceData) terminals: TypedTerminalReferenceData[];
}
